import './index.css';

function Toast({ show, text, duration, onHide }) {

  duration = duration || 5
  text = text || ""

  if (show) {
    setTimeout(() => {
      onHide && onHide()
    }, duration * 1000)
  }

  return (
    <div className='toast-cont'>
      <div className={`toast ${show ? "show" : "hide"}`}>
        {text}
      </div>
    </div>
  )
}

export default Toast
